document.addEventListener("DOMContentLoaded", function () {

  const openBtn = document.querySelector(".header__icon--menu");
  const closeBtn = document.querySelector(".custom-menu-close");
  const menu = document.querySelector(".custom-mobile-menu");
  const overlay = document.querySelector(".custom-menu-overlay");

  openBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    menu.classList.add("active");
    overlay.classList.add("active");
  });

  closeBtn?.addEventListener("click", function () {
    menu.classList.remove("active");
    overlay.classList.remove("active");
  });

  overlay?.addEventListener("click", function () {
    menu.classList.remove("active");
    overlay.classList.remove("active");
  });


  document.querySelectorAll(".menu-row").forEach(function(row){

    row.addEventListener("click",function(){

      let submenu=this.nextElementSibling;

      submenu.classList.toggle("active");

      let icon=this.querySelector(".submenu-toggle");

      icon.innerHTML=submenu.classList.contains("active")
      ?"−"
      :"+";

    });

  });

});